import React from 'react';
import {
    SideNavigation,
    Flash,Badge
} from 'AWS-UI-Components-React';


const items=[
    {type: 'link', text: 'Entity Instance Lifecycle', href: '#/lifecycle'},
    { type: "divider" },
    {
        type: "link",
        text: "Documentation",
        href: "https://w.amazon.com/bin/view/FinOpsCentral/Hackathon/FOCUserDashboard/",
        external: true
    }
];

const header={
    "href": "/",
    "text": "Home"
};

class Navigation extends React.Component {
    onFollowHandler(ev) {
        ev.preventDefault();
    }

    render() {
        return (
            <SideNavigation
                items={items}
                header={header}
                activeHref={`#/`}
                // onFollow={this.onFollowHandler.bind(this)}
            />
        );
    }
}

export default (Navigation);


// WEBPACK FOOTER //
// ./src/components/navigation.jsx